export default __webpack_public_path__ + "static/b2bpuzzelpieces-c078d7feede4537e2b5dbebfaf893786.png";